import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useRef } from 'react';
import { useForkedRef } from "../../hooks";
import { StyledInput, InputContainer } from "./TextField.styles";
import { InputAdornment } from "./InputAdornment";
import { TextFieldLabel } from "./TextFieldLabel";
import { Stack } from "../Stack";
import { useId } from '@reach/auto-id';
import { TextFieldHelp } from "./TextFieldHelp";
import { InputErrorAdornment } from "./InputErrorAdornment";
import { InlineError } from "./InlineError";
export var TextField = React.forwardRef(function (_ref, forwardedRef) {
  var placeholder = _ref.placeholder,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      adornmentBefore = _ref.adornmentBefore,
      adornmentAfter = _ref.adornmentAfter,
      disabled = _ref.disabled,
      className = _ref.className,
      label = _ref.label,
      style = _ref.style,
      helpText = _ref.helpText,
      idProp = _ref.id,
      error = _ref.error,
      _ref$errorVariant = _ref.errorVariant,
      errorVariant = _ref$errorVariant === void 0 ? 'tooltip' : _ref$errorVariant,
      _ref$muted = _ref.muted,
      muted = _ref$muted === void 0 ? false : _ref$muted,
      other = _objectWithoutProperties(_ref, ["placeholder", "size", "adornmentBefore", "adornmentAfter", "disabled", "className", "label", "style", "helpText", "id", "error", "errorVariant", "muted"]);

  var containerRef = useRef(null);
  var id = useId(idProp);
  var ownRef = useRef(null);
  var ref = useForkedRef(forwardedRef, ownRef);
  var hasError = Boolean(error);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    gap: 4
  }, label && /*#__PURE__*/React.createElement(TextFieldLabel, {
    htmlFor: id
  }, label), /*#__PURE__*/React.createElement(InputContainer, {
    $hasError: hasError,
    $muted: muted,
    disabled: disabled,
    ref: containerRef,
    className: className,
    style: style
  }, adornmentBefore && /*#__PURE__*/React.createElement(InputAdornment, {
    $size: size,
    $placement: "start"
  }, adornmentBefore), /*#__PURE__*/React.createElement(StyledInput, _extends({
    $size: size,
    ref: ref,
    "aria-label": label ? undefined : placeholder,
    placeholder: placeholder,
    disabled: disabled,
    autoComplete: "off",
    id: id
  }, other)), /*#__PURE__*/React.createElement(InputErrorAdornment, {
    errorVariant: errorVariant,
    error: error
  }), adornmentAfter && /*#__PURE__*/React.createElement(InputAdornment, {
    $size: size,
    $placement: "end"
  }, adornmentAfter))), /*#__PURE__*/React.createElement(InlineError, {
    error: error,
    errorVariant: errorVariant
  }), helpText && /*#__PURE__*/React.createElement(TextFieldHelp, {
    paddingLeft: "px",
    paddingTop: 4
  }, helpText));
});